import axios from "axios";
import { Form, Formik } from "formik";
import React, { useCallback } from "react";
import Dropzone from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { handleUploadImageToS3 } from "../../helpers";
import { useLocalStorage } from "../../hooks";
import * as userActions from "../../redux/reducers/userReducer";
import { userState } from "../../redux/reducers/userReducer";

import { EyeIcon, EyeSlashIcon } from "@heroicons/react/20/solid";
import { useGoogleLogin } from "@react-oauth/google";
import avatar_placeholder_vector from "../../assets/avatar_placeholder.png";
import customer_name from "../../assets/customer_name.svg";
import lock_img from "../../assets/password.svg";
import { TwButton, TwFormHelperText, TwInputGroup, TwPhoneInputGroup } from "../../components/tailwind";
import { useToast } from "../../provider/ToastProvider";
import { loadingState, setActionLoading } from "../../redux/reducers/loadingReducer";
import { getUrlForUsers } from "../../utils/confighelpers";
import { useTranslation } from "react-i18next";

export default function SignUpForm(props) {
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loadingReduxState = useSelector(loadingState);
  const [passwordVisible, setPasswordVisible] = React.useState(false);
  const [userToken, setUserToken] = useLocalStorage("userToken", "");
  const userReduxState = useSelector(userState);

  const onLoginStart = useCallback(() => { }, []);

  const onSignUp = async (body, values = null, setSubmitting = () => { }) => {

    dispatch(setActionLoading(true));
    const request = await axios.post(
      `${getUrlForUsers()}registration`,
      body
    );
    dispatch(setActionLoading(false));
    setSubmitting(false);
    if (request.status === 200) {
      if (request.data.statusCode === 500 || request.data.statusCode === 403) {
        addErrorToast(request.data.message);
        return;
      }
      if (body.socialType !== "normal") {
        // addSuccessToast(t("successes.success"))

        let name = body.socialData.name;
        dispatch(userActions.setOnBoardingData(
          {
            sentFromSignupComplete: true,
            ...request.data.data,
            name: request.data.data.fullName,
          },
        ));
        dispatch(
          userActions.setUserData(request.data.data)
        );
        dispatch(
          userActions.setUserPhone("")
        );
        setUserToken(request.data.data.token);
        navigate("/on-bording", { /** new on-bording **/
          state: { from: "list", name, socialType: body.socialType, username: body.username, ...body, sentFromSignupComplete: true, },
        });
      } else {
        // addSuccessToast(t("successes.success"))
        const onBordingData = {
          username: values.countryCode + "" + values.phone,
          // avatar: values.avatar,
          profilePic: values.profilePic,
          countryName: values.countryName,
          countryCode: values.countryCode,
          number: values.phone,
          phoneNumber: values.phone,
          formattedPhoneNumber: values.formattedPhoneNumber,
          // name: values.name,
          fullName: values.name,
          password: values.password,
          response: request.data,
          socialType: body.socialType
        }

        dispatch(userActions.setOnBoardingData(onBordingData));
        navigate("/signup/verifynumber", {
          // navigate("/on-bording", {
          state: onBordingData,
        });
      }
    } else {
      addErrorToast(t("signup.errorOopsSignup"));
    }
  }

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      const userInfo = await axios.get(
        'https://www.googleapis.com/oauth2/v3/userinfo',
        { headers: { Authorization: `Bearer ${tokenResponse.access_token}` } },
      );

      const body = {
        username: userInfo.data.email,
        // password: "",
        appToken: "k4zJNUAAv9eGQbZXuZf0SPMnuhr6vXfl",
        deviceType: "Web",
        userType: "teacher",
        socialType: 'google',
        socialToken: tokenResponse.access_token,
        socialData: {
          ...JSON.parse(JSON.stringify({
            ...userInfo.data,
            ...tokenResponse,
            provider: 'google',
          })),
        },
      };

      await onSignUp(body);
    },
    onError: errorResponse => console.log(errorResponse),
  });

  React.useEffect(() => {
    if (userToken !== undefined && userToken !== "" && userReduxState.userData?.fullName) {
      // navigate("/home/dashboard");
      window.location.href = "/home/dashboard";
    }
  }, []);

  return (
    <Formik
      initialValues={{
        profilePic:
          location.state !== null
            ? location.state.profilePic
            : "",
        // : avatar_placeholder_vector,
        countryName:
          location.state !== null ? location.state.countryName : "nl",
        countryCode: location.state !== null ? location.state?.countryCode || "+31" : "",
        phone: location.state !== null ? location.state.number : "",
        formattedPhoneNumber:
          location.state !== null ? location.state.formattedPhoneNumber : "",
        name: location.state !== null ? location.state.name : "",
        password: location.state !== null ? location.state.password : "",
      }}
      // validateOnChange={false}
      // validateOnBlur={false}
      validate={(values) => {
        const errors = {};
        if (!values.phone) {
          errors.phone = t("errors.required");
        }

        if (!values.name) {
          errors.name = t("errors.required");
        }

        if (!values.password) {
          errors.password = t("errors.required");
        } else if (values.password.length < 8) {
          errors.password = t("errors.passwordSyntax");
        }
        return errors;
      }}
      onSubmit={async (values, { setSubmitting }) => {

        const body = {
          countryCode: values.countryCode,
          phoneNumber: values.phone,
          formattedPhoneNumber: values.formattedPhoneNumber,
          socialType: "normal",
          userType: "teacher",
        };
        await onSignUp(body, values, setSubmitting)

      }}
    >
      {({
        submitForm,
        isSubmitting,
        errors,
        setFieldValue,
        setErrors,
        setFieldError,
        touched,
        values,
        handleBlur,
      }) =>
        !userToken ? (
          <Form>
            <div className={"flex flex-col gap-4"}>
              {/* <div
                className={
                  "flex flex-row justify-center items-center"
                }
              >
                <Dropzone
                  accept="image/png, image/jpeg"
                  noDrag={true}
                  onDrop={async (files) => {
                    const formErrors = { ...errors };
                    setFieldError("profilePic", "")
                    if (files[0]) {
                      addToast("Uploading...");
                      const file = await handleUploadImageToS3(files[0]);
                      if (file.result.ok) {
                        setFieldValue("profilePic", file.location);
                      }
                    } else {
                      setFieldValue("profilePic", values?.profilePic || "");
                      formErrors.profilePic = "Only PNG and JPG formats are allowed";
                      setFieldError("profilePic", "Only PNG and JPG formats are allowed")
                    }
                    setErrors({ ...formErrors });
                  }}
                >
                  {({ getRootProps, getInputProps }) => {
                    return (
                      <div
                        {...getRootProps({ className: "dropzone" })}
                        className={
                          ""
                        }
                      >
                        <input {...getInputProps()} />
                        <img
                          className={`w-36 h-36 sm:w-36 sm:h-36 rounded-full border-gray-700 ${values.profilePic !== ""
                            ? "border-0 object-cover"
                            : "border object-scale-down"
                            } `}
                          src={values.profilePic || avatar_placeholder_vector}
                          alt={"your-profile-photo"}
                        />
                      </div>
                    );
                  }}
                </Dropzone>
                {touched["profilePic"] && errors["profilePic"] && (
                  <TwFormHelperText error={errors?.profilePic != ""}>{errors["profilePic"]}</TwFormHelperText>
                )}
              </div> */}
              <TwPhoneInputGroup
                label={t("inputFieldsTitle.mobileNumber")}
                placeholder={t("inputFieldsTitle.mobileNumber")}
                name={"phone"}
                country={values.countryName}
                onBlur={() => handleBlur("phone")}
                onChange={(phone, country, e) => {
                  const numberWithoutDialCode = phone.split("");
                  for (let i = 0; i < country.dialCode.length; i++) {
                    numberWithoutDialCode.shift();
                  }
                  let dialCode = country.dialCode;
                  if (
                    country.format.includes("+") &&
                    !country.dialCode.includes("+")
                  ) {
                    dialCode = "+".concat(country.dialCode);
                  }
                  setFieldValue("countryName", country.countryCode);
                  setFieldValue("countryCode", dialCode);
                  setFieldValue("phone", numberWithoutDialCode.join(""));
                  setFieldValue("formattedPhoneNumber", e.target.value);
                }}
                errors={touched["phone"] ? errors : {}}
              />
              <TwInputGroup
                label={t("profile.fullName")}
                placeholder={t("profile.fullName")}
                name={"name"}
                leftIcon={(<img className={""} src={customer_name} alt={""} />)}
                value={values.fullName}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                }}
                errors={touched["name"] ? errors : {}}
              />
              <TwInputGroup
                label={t("inputFieldsTitle.password")}
                placeholder={t("inputFieldsTitle.passwordPlaceholder")}
                name={"password"}
                type={passwordVisible ? "text" : "password"}
                leftIcon={(<img className={""} src={lock_img} alt={""} />)}
                rightIcon={
                  passwordVisible ? (
                    <EyeIcon className="size-5" onClick={() => setPasswordVisible(!passwordVisible)} />
                  ) : (
                    <EyeSlashIcon className="size-5" onClick={() => setPasswordVisible(!passwordVisible)} />
                  )
                }
                onChange={(e) => {
                  setFieldValue("password", e.target.value);
                }}
                errors={touched["password"] ? errors : {}}
              />
              <TwButton
                variant={"secondary"}
                onClick={submitForm}
                disabled={loadingReduxState.actionLoading || isSubmitting}
                actionLoading={(loadingReduxState.actionLoading)}
                className="w-full xs:text-base sm:text-xl md:py-3.5 mt-2.5"
              >
                {t("inputFieldsTitle.continue")}
              </TwButton>
              <div className="relative flex py-4 items-center">
                <div className="flex-grow border-t border-gray-300"></div>
                <span className="flex-shrink mx-4 text-gray-500 text-sm">{t("linkDescription.orContinueWith")}</span>
                <div className="flex-grow border-t border-gray-300"></div>
              </div>
              <button
                type="button"
                className="!p-0 xs:text-base sm:text-xl"
                onClick={googleLogin}
              >
                <div className="w-full flex justify-center items-center rounded-lg  border border-[#e2e8f0] p-3 cursor-pointer w-full">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="26px" height="26px"><linearGradient id="95yY7w43Oj6n2vH63j6HJb" x1="29.401" x2="29.401" y1="4.064" y2="106.734" gradientTransform="matrix(1 0 0 -1 0 66)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#ff5840"></stop><stop offset=".007" stopColor="#ff5840"></stop><stop offset=".989" stopColor="#fa528c"></stop><stop offset="1" stopColor="#fa528c"></stop></linearGradient><path fill="url(#95yY7w43Oj6n2vH63j6HJb)" d="M47.46,15.5l-1.37,1.48c-1.34,1.44-3.5,1.67-5.15,0.6c-2.71-1.75-6.43-3.13-11-2.37	c-4.94,0.83-9.17,3.85-11.64, 7.97l-8.03-6.08C14.99,9.82,23.2,5,32.5,5c5,0,9.94,1.56,14.27,4.46	C48.81,10.83,49.13,13.71,47.46,15.5z"></path><linearGradient id="95yY7w43Oj6n2vH63j6HJc" x1="12.148" x2="12.148" y1=".872" y2="47.812" gradientTransform="matrix(1 0 0 -1 0 66)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#feaa53"></stop><stop offset=".612" stopColor="#ffcd49"></stop><stop offset="1" stopColor="#ffde44"></stop></linearGradient><path fill="url(#95yY7w43Oj6n2vH63j6HJc)" d="M16.01,30.91c-0.09,2.47,0.37,4.83,1.27,6.96l-8.21,6.05c-1.35-2.51-2.3-5.28-2.75-8.22	c-1.06-6.88,0.54-13.38, 3.95-18.6l8.03,6.08C16.93,25.47,16.1,28.11,16.01,30.91z"></path><linearGradient id="95yY7w43Oj6n2vH63j6HJd" x1="29.76" x2="29.76" y1="32.149" y2="-6.939" gradientTransform="matrix(1 0 0 -1 0 66)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#42d778"></stop><stop offset=".428" stopColor="#3dca76"></stop><stop offset="1" stopColor="#34b171"></stop></linearGradient><path fill="url(#95yY7w43Oj6n2vH63j6HJd)" d="M50.45,51.28c-4.55,4.07-10.61,6.57-17.36,6.71C22.91,58.2,13.66,52.53,9.07,43.92l8.21-6.05	C19.78,43.81, 25.67,48,32.5,48c3.94,0,7.52-1.28,10.33-3.44L50.45,51.28z"></path><linearGradient id="95yY7w43Oj6n2vH63j6HJe" x1="46" x2="46" y1="3.638" y2="35.593" gradientTransform="matrix(1 0 0 -1 0 66)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#155cde"></stop><stop offset=".278" stopColor="#1f7fe5"></stop><stop offset=".569" stopColor="#279ceb"></stop><stop offset=".82" stopColor="#2cafef"></stop><stop offset="1" stopColor="#2eb5f0"></stop></linearGradient><path fill="url(#95yY7w43Oj6n2vH63j6HJe)" d="M59,31.97c0.01,7.73-3.26,14.58-8.55,19.31l-7.62-6.72c2.1-1.61,3.77-3.71,4.84-6.15 c0.29-0.66-0.2-1.41-0.92-1.41H37c-2.21,0-4-1.79-4-4v-2c0-2.21,1.79-4,4-4h17C56.75,27,59,29.22,59,31.97z"></path></svg>
                  <span className="flex-shrink mx-4 [text-[#2F80ED]]">{t("inputFieldsTitle.continueWithGoogle")}</span>
                </div>
              </button>
              <p className={"text-center sm:text-sm sm:mx-2 md:text-sm max-w-md"}>
                {t("linkDescription.tnpLine1")}
                <a
                  className={"inline-block"}
                  style={{ color: "gray", textDecoration: "underline" }}
                  href={"https://www.tikitly.com/terms-conditions.html"}
                  target="_blank" rel="noreferrer"
                >
                  {t("linkDescription.tnpTermsOfUse")}
                </a>{" "}
                {t("linkDescription.tnpLine2")}
                <a
                  className={"inline-block"}
                  style={{ color: "gray", textDecoration: "underline" }}
                  href={"https://www.tikitly.com/privacy-policy.html"}
                  target="_blank" rel="noreferrer"
                >
                  {t("linkDescription.tnpPrivacyPolicy")}
                </a>
              </p>
              <p className={"text-sm text-center"}>
                {t("signup.alreadySignup")}{" "}
                <button
                  className={
                    "text-primary font-bold transition-opacity active:opacity-50"
                  }
                  onClick={() => navigate("/")}
                >
                  {t("account.signIn")}
                </button>
              </p>
            </div>
          </Form>
        ) : ""
      }
    </Formik>
  );
}
